export default "__VITE_ASSET__BjVCwQqR__"